import React from "react";
import PropTypes from "prop-types";
import { getCurrencySymbol } from "../../../utils/currencySymbols";

const PriceSummary = ({ t, currencyCode, calculateServiceTypeTotal }) => {
  const summaryItems = [
    { key: "oem", colorClass: "teal-item", label: t("oem_icon") },
    {
      key: "recommended",
      colorClass: "blue-item",
      label: t("recommended_icon"),
    },
    {
      key: "optional",
      colorClass: "green-item",
      label: t("optional_icon"),
    },
  ];

  return (
    <div className="card-header bg-gray">
      <ul className="price-section list-unstyled m-0">
        {summaryItems.map(({ key, colorClass, label }) => {
          const total = calculateServiceTypeTotal(key);
          return (
            <li key={key}>
              <div className={`price-item ${colorClass}`}>
                <div className="price-tag">{label}</div>
                <div className={`price ${total > 0 ? "fw-bold" : ""}`}>
                  {getCurrencySymbol(currencyCode)}
                  {total}
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

PriceSummary.propTypes = {
  t: PropTypes.func.isRequired,
  currencyCode: PropTypes.string.isRequired,
  calculateServiceTypeTotal: PropTypes.func.isRequired,
};

export default PriceSummary;
